export default {
  title: 'الإعدادات',
  edit: {
    title: 'تعديل الإعدادات'
  },
  parameters: {
    PASSWORD_EXPIRATION_DELAY: 'مدة انتهاء صلاحية كلمة المرور'
  },
  success: {
    update: 'تم تحديث الإعدادات',
    delete: 'تم إعادة تعيين الإعدادات'
  },
  errors: {
    update: 'تعذر تحديث الإعدادات',
    loading: 'تعذر تحميل الإعدادات',
    delete: 'تعذر إعادة تعيين الإعدادات'
  },
  disabled: 'معطل'
}
